import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "@/components/feature/ScrollToTop";
import TicketInstructionsHelp from "@/components/feature/TicketInstructionsHelp";
import { useReloadAfterInactivity } from "@/hooks/useReloadAfterInactivity";

function App() {
  useReloadAfterInactivity();

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <ScrollToTop />
        <TicketInstructionsHelp />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
